<mat-card>
  <mat-card-title class="text-center">404: Page Not Found!</mat-card-title>
  <mat-card-content>
    <p class="text-center">Sorry, You have reached a page which doesn't exist or was removed.</p>
  </mat-card-content>
  <mat-card-actions class="text-center">
    <button mat-raised-button [routerLink]="['/admin/landing1']" color="primary">Home</button>
    <button mat-raised-button (click)="goBack()" color="primary">Back</button>
  </mat-card-actions>
</mat-card>
